var _Path, _Path2, _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, G, Circle, Rect, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
function SvgAppointmentMake(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 97,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M67.693 81.606c-20.148 11.895-44.85 6.715-55.174-11.569-10.324-18.284-2.36-42.749 17.788-54.644C50.455 3.5 75.157 8.68 85.481 26.964c10.324 18.284 2.36 42.749-17.788 54.643z",
    fill: "#C0E9D3"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M70.884 86.554c-23.588 13.852-52.507 7.82-64.594-13.473C-5.796 51.788 3.528 23.298 27.116 9.446 50.704-4.406 79.623 1.626 91.71 22.919c12.086 21.293 2.762 49.783-20.826 63.635z",
    fill: "#C0E9D3"
  })), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#appointment-make_svg__filter0_d_2365_44496)"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 23.5,
    cy: 48.499,
    r: 19,
    transform: "rotate(-180 23.5 48.499)",
    fill: "#F6F5F3",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M57.03 43.998v6.297c0 1.302.495 2.555 1.384 3.506l.838.895a4.154 4.154 0 01-.941 6.428l-.472.275c-2.524 1.472-2.54 5.114-.027 6.607l1.08.64c8.042 4.778 7.267 16.68-1.264 20.52-12.374 5.568-26.681 5.4-38.883-.536-7.902-3.843-8.697-14.792-1.434-19.737l2.733-1.86a7.905 7.905 0 003.457-6.535v-11.96",
    stroke: "#2F2F2F",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement(G, {
    filter: "url(#appointment-make_svg__filter1_d_2365_44496)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M25 55.499a1.5 1.5 0 00-3 0v4a1.5 1.5 0 103 0v-4z",
    fill: "#FDFAA0"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M23.5 53.499a2 2 0 012 2v4a2 2 0 11-4 0v-4a2 2 0 012-2z",
    stroke: "#2F2F2F"
  })), /*#__PURE__*/React.createElement(Rect, {
    x: 36.5,
    y: 3.499,
    width: 6,
    height: 5,
    rx: 2.5,
    fill: "#FFE5E5",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 71.5,
    y: 3.499,
    width: 6,
    height: 5,
    rx: 2.5,
    fill: "#FFE5E5",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M36.065 5.999h-.421a4.507 4.507 0 00-4.507 4.506v.844A27.993 27.993 0 0049.15 37.507a22.005 22.005 0 0015.683.002A28.019 28.019 0 0082.87 11.337v-.83a4.507 4.507 0 00-4.507-4.508h-.42",
    stroke: "#2F2F2F",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M57 37.499a2.5 2.5 0 012.5 2.5v7a2.5 2.5 0 01-5 0v-7a2.5 2.5 0 012.5-2.5z",
    fill: "#FDFAA0",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(G, {
    filter: "url(#appointment-make_svg__filter2_d_2365_44496)",
    transform: "rotate(-180 23.5 48.499)"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 23.5,
    cy: 48.499,
    r: 7.5,
    fill: "#FFCED3"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 23.5,
    cy: 48.499,
    r: 7,
    stroke: "#2F2F2F"
  })), /*#__PURE__*/React.createElement(Rect, {
    x: 0.5,
    y: -0.5,
    width: 30.398,
    height: 29.576,
    rx: 2.5,
    transform: "matrix(-1 0 0 1 92.002 59.424)",
    fill: "#fff",
    stroke: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M91.002 61.424a2 2 0 00-2-2H63.604a2 2 0 00-2 2v6.467h29.398v-6.467z",
    fill: "#FFCED3"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M73 75.5a1 1 0 100 2v-2zm7 2a1 1 0 100-2v2zm-7 0h7v-2h-7v2zm2.5-5.5v9h2v-9h-2z",
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M91.002 79.031a.5.5 0 01.355.852l-8.4 8.467a.5.5 0 01-.855-.352v-6.467a2.5 2.5 0 012.5-2.5h6.4z",
    fill: "#F6F5F3",
    stroke: "#2F2F2F",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 67.9,
    y: 56.25,
    width: 2.1,
    height: 6.35,
    rx: 1.05,
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 75.25,
    y: 56.25,
    width: 2.1,
    height: 6.35,
    rx: 1.05,
    fill: "#2F2F2F"
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 82.602,
    y: 56.25,
    width: 2.1,
    height: 6.35,
    rx: 1.05,
    fill: "#2F2F2F"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)));
}
export default SvgAppointmentMake;